// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","6863": "454c9f289029","8561": "f9cad78a6d35","8990": "7d69c8cdd354","9967": "e075b0c48808",}[chunkId] + ".css"
}